import { Utilities } from '@shared/utilities/utilities.model';

export class FormItemsModel {

	rearPlateStatus?: string;
	frontPlateStatus: string;
	isPlateInstalled: boolean;
	vehicle_registration: boolean;
	expectedDeliveryDate: Date;
	aldMaterialReceiptDate: Date;

	chassis: string;
	processingAt: string;
	processingDate: Date;
	processingCenterAddress: string;

	canBeSentToFleetManager: boolean;
	canBeSentToAssistanceCenter: boolean;
	canBeAdministrationPracticeClosed: boolean;
	canBeAdministrationPracticeReject: boolean;
	canBeDeleteAttachment: boolean;
	canBeUploadAttachment: boolean;
	id: string;
	listForms: number;

	declinedNote: string;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.rearPlateStatus = model.rear_plate_status;
			this.frontPlateStatus = model.front_plate_status;
			this.isPlateInstalled = model.is_plate_installed;
			this.expectedDeliveryDate = model.expected_delivery_date;
			this.aldMaterialReceiptDate = model.ald_material_receipt_date;
			this.chassis = model.chassis;
			this.processingAt = model.processing_at;
			this.processingDate = model.processing_date;
			this.processingCenterAddress = model.processing_center_address;
			this.canBeSentToFleetManager = model.can_be_sent_to_fleet_manager;
			this.canBeSentToAssistanceCenter = model.can_be_sent_to_assistance_center;
			this.canBeAdministrationPracticeClosed = model.can_be_administration_practice_closed;
			this.canBeAdministrationPracticeReject = model.can_be_administration_practice_reject;
			this.canBeDeleteAttachment = model.can_be_delete_attachment;
			this.canBeUploadAttachment = model.can_be_upload_attachment;
		}
	}

}
